import { Expose, Transform, Type } from 'class-transformer';
import { DateTimeHelper } from '../../../features/calendar/util/date-time-helper';
import { AnnualVacationQuotaModel } from './annual-vacation-quota.model';
import { CostRateEntryModel } from './cost-rate-entry.model';
import { WorkingTimeModel } from './working-time.model';

export class UserModel {
  public id: number = null;

  @Expose({ name: 'first_name' })
  public firstName = '';

  @Expose({ name: 'last_name' })
  public lastName = '';

  public email = '';

  public username = '';

  public created_date = new Date();

  @Expose({ name: 'employee_hire_date' })
  @Transform(({ value }) => DateTimeHelper.format(value), { toPlainOnly: true })
  @Transform(({ value }) => new Date(value), { toClassOnly: true })
  public employeeHireDate: Date | null = null;

  @Expose({ name: 'annualvacationquota_set' })
  @Type(() => AnnualVacationQuotaModel)
  public annualVacationQuotaEntries: readonly AnnualVacationQuotaModel[] = [];

  @Expose({ name: 'workingtime_set' })
  @Type(() => WorkingTimeModel)
  public workingTimeEntries: readonly WorkingTimeModel[] = [];

  @Expose({ name: 'costrateentry_set' })
  @Type(() => CostRateEntryModel)
  public costRateEntries: readonly CostRateEntryModel[] = [];
}
